export default "__VITE_ASSET__BoF96diR__ 120w, __VITE_ASSET__BK$fN0m3__ 240w, __VITE_ASSET__C6awXrn5__ 480w, __VITE_ASSET__BCwJeGgf__ 512w";